module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comment-list",
    class: _vm.isFromMiniProgram ? 'mini-program' : ''
  }, [_c('div', {
    staticClass: "desc"
  }, [_vm._v("\n    评论(" + _vm._s(_vm.count) + ")\n  ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isShowNo),
      expression: "!isShowNo"
    }],
    staticClass: "list"
  }, [_c('ul', _vm._l((_vm.commentList), function(item) {
    return _c('li', [_c('a', {
      staticClass: "item Fix"
    }, [_c('div', {
      staticClass: "pic"
    }, [_c('a', {
      staticClass: "display:inline-block;width: 100%;height:100%",
      attrs: {
        "href": _vm.getUserHref(item.userId)
      }
    }, [_c('img', {
      attrs: {
        "src": item.userPic,
        "alt": ""
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('div', {
      staticClass: "name"
    }, [_c('a', {
      attrs: {
        "href": _vm.getUserHref(item.userId)
      }
    }, [_c('span', {
      staticClass: "user_name"
    }, [_vm._v("\n                      " + _vm._s(item.userName) + "\n                  ")])]), _vm._v(" "), _c('span', {
      staticClass: "time"
    }, [_vm._v("\n                  " + _vm._s(item.time) + "\n                ")])]), _vm._v(" "), _c('div', {
      staticClass: "comment"
    }, [_c('span', [_vm._v(_vm._s(item.reviewBody))])])])])])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowMore),
      expression: "isShowMore"
    }],
    staticClass: "more-list"
  }, [_c('a', {
    staticClass: "btn-more",
    on: {
      "click": _vm.getMoreComment
    }
  }, [_vm._v("\n        查看更多评论\n        "), _c('i')])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowNo),
      expression: "isShowNo"
    }],
    staticClass: "no-comment"
  }, [(_vm.isFromMiniProgram) ? _c('a', [_vm._m(0)]) : _c('a', {
    attrs: {
      "href": _vm.detailHref
    }
  }, [_vm._m(1)])]), _vm._v(" "), (!_vm.isFromMiniProgram) ? _c('a', {
    staticClass: "forward",
    attrs: {
      "href": _vm.detailHref
    }
  }, [_c('div', {
    staticClass: "add-comment"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "num"
  }, [_c('div', {
    staticClass: "comment"
  }, [_c('i', {
    staticClass: "icon"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.count))])]), _vm._v(" "), _c('div', {
    staticClass: "flower",
    class: {
      isSendFlower: _vm.isSendFlower
    }
  }, [_c('i', {
    staticClass: "icon"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.flowerNum))])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('i')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('i'), _vm._v(" "), _c('p', {
    staticClass: "p-desc"
  }, [_vm._v("看视频，抢沙发！")]), _vm._v(" "), _c('p', {
    staticClass: "p-btn"
  }, [_vm._v("添加第一条评论")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "msg"
  }, [_c('span', [_vm._v("hi,留下你的留言吧")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8b2d24e0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/comment.vue
// module id = 623
// module chunks = 10